import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

const NoDiagnosisDialog = ({ isOpen, onExit }) => (
  <Dialog
    modal
    open={isOpen}
    bodyStyle={{ color: '#222222' }}
    actions={[<FlatButton primary label="OK" onClick={onExit} />]}
  >
    <h5 style={{ marginBottom: '0.5em' }}>
      <FormattedMessage id="nodiagnosisdialog.header" />
    </h5>
    <h6 style={{ marginBottom: '1.25em' }}>
      <FormattedMessage id="nodiagnosisdialog.subHeader" />
    </h6>
    <p style={{ marginBottom: '1.25em' }}>
      <FormattedMessage id="nodiagnosisdialog.body" />
    </p>
    <p>
      <b>
        <FormattedMessage id="nodiagnosisdialog.exitText" />
      </b>
    </p>
  </Dialog>
);

NoDiagnosisDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onExit: PropTypes.func.isRequired,
};

export default NoDiagnosisDialog;
